/** @format */
import { Col, Row, Grid } from "antd";

interface Sec1 {
  locationtypeData: any;
}

export default function Sec1({ locationtypeData }: Sec1) {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();
  return (
    <Row
      justify='center'
      style={{
        color: "#fff",
        backgroundImage: `url(${locationtypeData?.acf?.background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: screenSize.xxl ? "700px" : "550px",
      }}>
      <Col
        lg={24}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "rgba(0, 0, 0, 0.6)",
          width: "100%",
        }}>
        <Row justify={"center"} style={{ display: "contents" }}>
          <Col
            lg={24}
            md={24}
            sm={23}
            style={{
              fontSize: screenSize.md ? 50 : 30,
              fontFamily: "adobe-garamond-pro",

              textAlign: "center",
              color: "#FFFFFF",
            }}>
            <p
              style={{
                fontWeight: 700,
                marginBottom: 15,
                fontSize: screenSize.md ? 60 : 30,
              }}>
              {locationtypeData?.acf?.city && locationtypeData?.acf?.state
                ? `${locationtypeData?.acf?.city} ${locationtypeData?.acf?.state}`
                : ""}
            </p>
            <p style={{ fontWeight: 400 }}>Office Location</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
